Pixlee.module('GridsApp', function(GridsApp, App, Backbone, Marionette, $) {
    var _this = this,
        API;
    GridsApp.Router = Marionette.AppRouter.extend({
        appRoutes: {
            "": "grid"
        }
    });

    var API = {
        grid: function() {
            // if (!window.chrome) {
            //     alert('The Live Grid is optimized for Google Chrome. Please download Google Chrome to get the best experience');
            // }
            var animations = ['fade', 'scrollHorz', 'scrollVert'];
            var orientations = ['zero', 'ninety'];
            var intervals = [1000, 3000, 5000, 10000, 15000];
            gon.grid_params = {};
            gon.fresh_images = [];
            gon.restricted_images = [];
            gon.currentLength = 0;
            gon.refreshTime = 3600000;
            gon.grid_params.interval = this.getParam('interval');
            gon.grid_params.animation = this.getParam('animation');
            gon.grid_params.row = this.getParam('row');
            gon.grid_params.column = this.getParam('column');
            gon.grid_params.offlineMode = this.getParam('offline');
            gon.grid_params.no_edit_mode = this.getParam('no_edit');
            gon.grid_params.pinned = {};

            var encoded = this.getParam('pinned');
            if (!_.isFalsy(encoded)) {
                try {
                    var decoded = JSON.parse(atob(encoded));
                    if (!_.isFalsy(decoded) && _.isObject(decoded) && !_.isFunction(decoded) && !_.isArray(decoded)) {
                        gon.grid_params.pinned = decoded;
                    }
                } catch (e) {
                    console.warn('Invalid grid URL');
                }
            }

            if (!gon.grid_params.row && !gon.grid_params.column) {
                gon.defaultSetting = true;
            }
            gon.grid_params.action_text = $.trim(decodeURIComponent(this.getParam('action_text')));
            if (gon.grid_params.action_text == 'undefined' || gon.grid_params.action_text.length == 0) {
                if (gon.hashtags && gon.hashtags.length > 0) {
                    gon.grid_params.action_text = gon.hashtags.replace(/,+$/, "");
                    if (gon.grid_params.action_text.indexOf(',') === 0) {
                        gon.grid_params.action_text = gon.grid_params.action_text.substr(1);
                    }
                    if (gon.grid_params.action_text.charAt(gon.grid_params.action_text.length - 1) == ',') {
                        gon.grid_params.action_text = gon.grid_params.action_text.substring(0, gon.grid_params.action_text.length - 1);
                    }
                    if (gon.grid_params.action_text.charAt(gon.grid_params.action_text.length - 2) == ',') {
                        gon.grid_params.action_text = gon.grid_params.action_text.substring(0, gon.grid_params.action_text.length - 2);
                    }
                } else {
                    gon.grid_params.action_text = '';
                }
            }
            if (gon.grid_params.interval) {
                try {
                    var interval = parseInt(gon.grid_params.interval);
                    gon.grid_params.interval = interval;
                    if ($.inArray(gon.grid_params.interval, intervals) == -1) {
                        gon.grid_params.interval = 3000;
                    }
                } catch (e) {
                    gon.grid_params.interval = 3000;
                }
            } else {
                gon.grid_params.interval = 3000;
            }

            if (!gon.grid_params.offlineMode) {
                gon.refreshIterations = gon.refreshTime / gon.grid_params.interval;
                gon.grid_params.offlineMode = false;
            }

            if (gon.grid_params.row) {
                try {
                    var row = parseInt(gon.grid_params.row);
                    if (row > 5) gon.grid_params.row = 5;
                    else gon.grid_params.row = row;
                } catch (e) {
                    gon.grid_params.row = 5;
                }
            } else {
                gon.grid_params.row = 5;
            }

            if (gon.grid_params.column) {
                try {
                    var column = parseInt(gon.grid_params.column);
                    if (column > 6) gon.grid_params.column = 6;
                    else gon.grid_params.column = column;
                } catch (e) {
                    gon.grid_params.column = 6;
                }
            } else {
                gon.grid_params.column = 6;
            }
            if ($.inArray(gon.grid_params.animation, animations) == -1) {
                gon.grid_params.animation = 'fade';
            }

            var _this = this;
            this.gridController = new GridsApp.Grid.Controller();

            $('#grid_footer').width($(window).width());
            $(window).resize(function() {
                $('#grid_footer').width($(window).width());
            });
            window.goFullscreen = function(elem) {
                var elem = document.getElementById(elem);
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.msRequestFullscreen) {
                    elem.msRequestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) {
                    elem.webkitRequestFullscreen();
                }
            }
        },
        getParam: function(sParam) {
            var sPageURL = window.location.search.substring(1);
            var sURLVariables = sPageURL.split('&');
            for (var i = 0; i < sURLVariables.length; i++) {
                var sParameterName = sURLVariables[i].split('=');
                if (sParameterName[0] == sParam) {
                    return sParameterName[1];
                }
            }
        },
        imageAdded: function(data) {
            this.gridController.trigger('image:added', data);
        },
        imageRemoved: function(data) {
            this.gridController.trigger('image:removed', data);
        },
        changeImage: function() {
            this.gridController.trigger('changed:image');
        },
        changeAnim: function() {
            this.gridController.trigger('changed:animation');
        },
        changePinURL: function() {
            this.gridController.trigger('changed:pin:url');
        }
    };

    GridsApp.on("start", function() {
        new GridsApp.Router({
            controller: API
        });
    });

    App.commands.setHandler('image:added', function(data) {
        API.imageAdded(data);
    });

    App.commands.setHandler('image:removed', function(data) {
        API.imageRemoved(data);
    });

    App.commands.setHandler('changed:image', function(data) {
        API.changeImage();
    });

    App.commands.setHandler('changed:animation', function(data) {
        API.changeAnim();
    });

    App.commands.setHandler('changed:pin:url', function(data) {
        API.changePinURL();
    });
});